import { uaCheck } from "./modules/utils";

uaCheck();
